import {Task} from '../../../entities';
import {
  InitialScheduleEditState,
  ScheduleEditState,
  TaskWithEditInfo,
} from '../types';

export const getMergedTasksWithEditState = (
  editState: ScheduleEditState = InitialScheduleEditState,
  originalTasks: Task[],
): TaskWithEditInfo[] => {
  const editKeys = Object.keys(editState.editedTasks).map(k => parseInt(k));
  if (editKeys.length === 0 && editState.currentPlaceholders.length === 0) {
    return originalTasks;
  }

  const editedTasks = editKeys.map(key => editState.editedTasks[key]);

  const withEditedTasks = originalTasks
    .filter(t => !editState.editedTasks[t.id])
    .concat(editedTasks);

  const placeholders = editState.currentPlaceholders;
  const withDragPlaceholders =
    placeholders.length === 0
      ? withEditedTasks
      : withEditedTasks
          .filter(t => t.id !== placeholders[0].id)
          .concat(placeholders);

  return withDragPlaceholders;
};
